import { STORE_TYPES } from '../config/tenantTypes';
import RetailModule from './retail';
import RentalModule from './rental';
import SupermarketModule from './supermarket';
import JewelleryModule from './jewellery';

export const MODULES = {
  [STORE_TYPES.SMALL_RETAIL]: RetailModule,
  [STORE_TYPES.BRIDAL_RENTAL]: RentalModule,
  [STORE_TYPES.SUPERMARKET]: SupermarketModule,
  [STORE_TYPES.JEWELLERY]: JewelleryModule,
};

export const getModuleByStoreType = (storeType) => {
  return MODULES[storeType] || MODULES[STORE_TYPES.SMALL_RETAIL];
};
